import ashWasteNomads from "./ash-waste-nomads.jpg";
import cawdorGotu from "./cawdor-gotu.jpg";
import cawdorHof from "cawdor-hof.jpg";
import chaosCult from "./chaos-cult.jpg";
import corpseCrinderCult from "./corpse-grinder-cult.jpg";
import delaque from "./delaque-hos.jpg";
import enforcers from "./enforcers.jpg";
import escher from "./escher-gotu.jpg";
import genestealerCult from "./genestealer-cult.jpg";
import goliath from "./goliath-gotu.jpg";
import orlock from "./orlock-gotu.jpg";
import vanSaar from "./van-saar-gotu.jpg";
import slaveOgryn from "./slave-ogryn.jpg";
import venators from "./venators.jpg";
import squat from "./squat-prospectors.jpg";
import ork from "./orks.jpg";
import pitSlave from "./pitSlave.jpg";

const Backgrounds = [
  cawdorGotu,
  goliath,
  vanSaar,
  orlock,
  escher,
  delaque,
  chaosCult,
  corpseCrinderCult,
  genestealerCult,
  ashWasteNomads,
  squat,
  enforcers,
  slaveOgryn,
  ork,
  pitSlave,
  venators
];


export const getRosterBackground = (factionEnum : number): string => Backgrounds[factionEnum - 1];
